export { default as SbpQrModalDesktop } from './ui/redesign/SbpQrModalDesktop'
export { default as OldSbpQrModalDesktop } from './ui/OldSbpQrModalDesktop'
export { default as SbpQrModalMobile } from './ui/SbpQrModalMobile'
